function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 10H11V8.5 10c0-1.7-1.3-3-3-3-1.1 0-2-.9-2-2s.9-2 2-2h10c.6 0 1 .4 1 1s-.4 1-1 1h-5.5H15c.6 0 1 .4 1 1s-.4 1-1 1h-1c-.6 0-1 .4-1 1v2h.5zM21 21H3s3-3.3 4.3-5.5C8.7 13.2 8.8 12 8.8 12c.1-.6.7-1 1.2-1h4c.6 0 1.1.4 1.2 1 0 0 .2 1.3 1.5 3.5S21 21 21 21z",
  fill: "currentColor"
});

var SvgLocationVolcano = function SvgLocationVolcano(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationVolcano;